import { executeRequest, Request, Response } from '@jfs/network'
import { getAPIURL, getPaymentHeader } from '../config'

const responseParser = (response: Response) => {
  const { data } = response
  return data
}

/**
 * New PG
 * Payment call for NB,CARD,Wallet and UPI
 * @param paymentDetails
 * @param deviceInfo
 */
const confirmPayment = (paymentDetails: any, deviceInfo: any, isSubscription: boolean) => {
  const deviceData = JSON.stringify(deviceInfo)
  const publicUrl = isSubscription ? getAPIURL('mandate') : getAPIURL('paymentsConfirm')
  const request: Request<{}> = {
    apiPath: publicUrl,
    method: 'POST',
    body: paymentDetails,
    headers: {
      ...getPaymentHeader(),
      'X-DEVICE-INFO': deviceData,
    },
  }
  return executeRequest(request)
    .then((data) => {
      return responseParser(data)
    })
    .catch((err) => {
      const {
        data: { error },
      } = err
      throw error
    })
}

/**
 * New PG
 * Payment status call for NB,CARD,Wallet and UPI
 * @param transactionId
 */
const getPaymentStatus = (transactionId: string) => {
  const input = {
    transactionId: transactionId,
  }

  const publicURL = getAPIURL('paymentsStatus')
  const request: Request<{}> = {
    apiPath: publicURL,
    cache: false,
    method: 'POST',
    body: input,
    headers: {
      ...getPaymentHeader(),
    },
  }
  return executeRequest(request)
    .then((data) => {
      if (data?.data?.transactionList) {
        return responseParser(data)
      } else {
        throw data
      }
    })
    .catch((err) => {
      const { data: { error = {} } = {} } = err
      throw error
    })
}

export { confirmPayment, getPaymentStatus }
